
// playground requires you to assign document definition to a variable called dd
export const convertToPDFTransactionStripReport = ({invoiceData, firm, date }) => {
    var dd =  {
		content: [
			{ text: 'DAY BOOK\n', style: "topHeader1" },
			{
				table: {
					widths: ['*'],
					body: [
						[
							{ text: 'DAYBOOK', style: "topHeader2" },
						],
						[
							{
								text:
									[
										{ text: 'Firm Name:-    ', bold: true },
										{ text: 'Google\n' },
                                        { text: 'Date:-               ', bold: true },
										{ text: '12/12/12\n' },
									]
								}
						],
					]
				}
			},
			{
				table: {
						body: [
						[
							{ text: 'STATEMENTS', style: "topHeader", colSpan: 7, decoration: 'underline' },
							// { text: '', style: "header" },
							{ text: '', style: "header" },
							{ text: '', style: "header" },
							{ text: '', style: "header" },
							{ text: '', style: "header" },
							{ text: '', style: "header" },
							{ text: '', style: "header" },
						],
						[
							// { text: 'Firm', style: "gstHeader" },
							{ text: 'Particulars', style: "gstHeader"},
							{ text: 'Debit', style: "gstHeader" },
							{ text: 'Credit', style: "gstHeader" },
							{ text: 'Voucher', style: "gstHeader" },
							{ text: 'Payment', style: "gstHeader"},
							{ text: 'Status', style: "gstHeader" },
							{ text: 'Remark', style: "gstHeader" },
						],
					
						]
				}
			},
		],
		styles: {
			header: {
				fontSize: 13,
				bold: true,
				alignment: 'center'
			},
			gstHeader: {
				fontSize: 14,
				bold: true,
				alignment: 'center'
			},
			data: {
				fontSize: 9,
				alignment: 'center'
			},
			topHeader: {
				color: 'white',
				fontSize: 12,
				alignment: 'center',
				bold: true,
				fillColor: '#15155d',
			},
			topHeader1: {
				color: 'white',
				fontSize: 1,
				alignment: 'center',
				bold: true,
				fillColor: '#15155d',
			},
			topHeader2: {
				color: 'white',
				fontSize: 14,
				alignment: 'center',
				bold: true,
				fillColor: '#15155d',
			},
			gstData1: {
				fontSize: 9,
				alignment: 'center',
				color: '#15155d',
				bold: true,	
			},
			gstData2: {
				fontSize: 9,
				alignment: 'center',
				color: '#B71C1C',
				bold: true,	
			},
			gstData3: {
				fontSize: 9,
				alignment: 'center',
				color: '#43A047',
				bold: true,	
			},
			gstData22: {
				fontSize: 9,
				alignment: 'center',
				color: '#B71C1C',
				bold: true,	
				fillColor: '#d8d8d8',
			},
			gstData32: {
				fontSize: 9,
				alignment: 'center',
				color: '#43A047',
				bold: true,	
				fillColor: '#d8d8d8',
			},
			data2: {
				fontSize: 9,
				alignment: 'center',
				fillColor: '#d8d8d8',
			},
			bigger: {
				fontSize: 18,
				bold: true,
				alignment: 'center',
				decoration: 'underline',
				decorationStyle: 'solid',
				decorationColor: 'black'
			}
		}
	}

    if (firm) {
        dd.content[1].table.body[1][0].text[1].text = firm + "\n";
    }
    if (date) {
        dd.content[1].table.body[1][0].text[3].text = date
    }

    invoiceData.map((invoice,index) => {
            dd.content[2].table.body.push(
                [
                    // { text: invoice[0], style: (index%2 == 0 ? "data" : "data2") },
                    { text: invoice[1], style: (index%2 == 0 ? "data" : "data2")},
                    { text: invoice[2], style: (index%2 == 0 ? "gstData3" : "gstData32") },
                    { text: invoice[3], style: (index%2 == 0 ? "gstData2" : "gstData22") },
                    { text: invoice[4], style: (index%2 == 0 ? "data" : "data2") },
                    { text: invoice[5], style: (index%2 == 0 ? "data" : "data2")},
                    { text: invoice[6], style: (index%2 == 0 ? "data" : "data2") },
                    { text: invoice[7], style: (index%2 == 0 ? "data" : "data2") },
                ]
            )
    })
    return dd;
}


// playground requires you to assign document definition to a variable called dd
export const convertToPDFTransactionReportFirm = ({invoiceData, firm, dateFrom, dateTo,bank }) => {
    var dd =   {
		content: [
		    	{
					table: {
						widths: ['50%','*'],
						body: [
						
							[
								
									{
									image: '',	
									width: 160,
									height: 35,
								},
									{
									text:
									[
										{
            								text:
            									[
            										{ text: 'Firm Name:    ', bold: true },
            										{ text: 'Google\n' },
                                                    { text: 'From Date:     ', bold: true },
            										{ text: '12/12/12\n' },
            										{ text: 'To Date:          ', bold: true },
            										{ text: '12/12/12\n' },
            									]
            								}
									]
									
								}, 
							 ],
						]
					},

					style: "topTab"
				},
	
			{
				table: {
						body: [
						[
							{ text: 'STATEMENTS', style: "topHeader", colSpan: 8, decoration: 'underline' },
							{ text: '', style: "header" },
							{ text: '', style: "header" },
							{ text: '', style: "header" },
							{ text: '', style: "header" },
							{ text: '', style: "header" },
							{ text: '', style: "header" },
							{ text: '', style: "header" },
						],
						[
							{ text: 'Date', style: "gstHeader" },
							{ text: 'Particulars', style: "gstHeader"},
							{ text: 'Debit', style: "gstHeader" },
							{ text: 'Credit', style: "gstHeader" },
							{ text: 'Voucher Type', style: "gstHeader" },
							{ text: 'Payment Type', style: "gstHeader"},
							{ text: 'Status', style: "gstHeader" },
							{ text: 'Remark', style: "gstHeader" },
						],
					
						]
				}
			},
		],
		styles: {
			header: {
				fontSize: 13,
				bold: true,
				alignment: 'center'
			},
			gstHeader: {
				fontSize: 14,
				bold: true,
				alignment: 'center'
			},
			data: {
				fontSize: 9,
				alignment: 'center'
			},
			topHeader: {
				color: 'white',
				fontSize: 12,
				alignment: 'center',
				bold: true,
				fillColor: '#15155d',
			},
			gstData1: {
				fontSize: 9,
				alignment: 'center',
				color: '#15155d',
				bold: true,	
			},
			gstData2: {
				fontSize: 9,
				alignment: 'center',
				color: '#B71C1C',
				bold: true,	
			},
			gstData3: {
				fontSize: 9,
				alignment: 'center',
				color: '#43A047',
				bold: true,	
			},
		}
	}

    if (firm) {
        dd.content[0].table.body[0][1].text[0].text[1].text = firm.toUpperCase() + "\n";
	}
	
	if(bank) {
		dd.content[0].table.body[0][1].text[0].text[0].text = "Bank Name:   ";
		dd.content[0].table.body[0][1].text[0].text[1].text = bank.toUpperCase() + "\n";
	}

    if (dateFrom) {
		dd.content[0].table.body[0][1].text[0].text[3].text = dateFrom + "\n";
	}
	if (dateTo) {
		dd.content[0].table.body[0][1].text[0].text[5].text = dateTo;
    }

    invoiceData.map((invoice) => {
            dd.content[1].table.body.push(
                [
					// { text: invoice[0], style: "data" },
                    { text: invoice[1], style: "data"},
                    { text: invoice[2], style: "gstData3" },
                    { text: invoice[3], style: "gstData2" },
                    { text: invoice[4], style: "data" },
                    { text: invoice[5], style: "data"},
                    { text: invoice[6], style: "data" },
					{ text: invoice[7], style: "data" },
					
                ]
            )
	})
	var imgToExport = document.getElementById('pdfimgToExportHorizontal');
	var canvas = document.createElement('canvas');
	canvas.width = imgToExport.width; 
	canvas.height = imgToExport.height; 
	canvas.getContext('2d').drawImage(imgToExport, 0, 0);
	let base64 = canvas.toDataURL('image/png')
	dd.content[0].table.body[0][0].image = base64;
    return dd;
}



// WEBPACK FOOTER //
// ./src/utils/pdf-reports/transaction-stripReports.js